import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLocale } from '../i18n/LocaleProvider';

export function Loading() {
  const { t } = useLocale();
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-muted-foreground">
      <Loader2 className="h-6 w-6 animate-spin text-gold" />
      <p className="font-num text-xs uppercase tracking-widest">{t.loading}</p>
    </div>
  );
}

export function ErrorState({ onRetry }) {
  const { t } = useLocale();
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
      <h2 className="font-display text-2xl text-greenDeep">{t.errorTitle}</h2>
      <p className="max-w-sm text-muted-foreground">{t.errorBody}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 rounded-full bg-greenDeep px-5 py-2 font-num text-xs uppercase tracking-wider text-cream transition-colors hover:bg-green"
        >
          {t.retry}
        </button>
      )}
    </div>
  );
}

export function Empty() {
  const { t } = useLocale();
  return (
    <div className="rounded-2xl border border-dashed border-sand bg-cream/50 py-20 text-center">
      <p className="font-display text-2xl text-greenDeep">{t.noOpenings}</p>
      <p className="mt-2 text-muted-foreground">{t.noOpeningsHint}</p>
    </div>
  );
}
